export class BootConstants {
  public static identityServiceEndpoint: string = getIdentityUrl();
  public static apiServiceEndpoint: string = getApiUrl();
}

function getIdentityUrl() {
  // return "https://192.168.50.156:5001/"; 
  
  if (isLocalhost()) {
    return "http://localhost:5001/";
  }
  else if (isStaging()) {
    return "https://identity-driverreporting-miljoeservice-staging.azurewebsites.net/";
  }
  else {
    return 'https://identity.miljoeservice.dk/';
  }
}

function getApiUrl() {
  // return "https://192.168.50.156:5000/api/";

  if (isLocalhost()) {
    return "http://localhost:5000/api/";
  }
  else if (isStaging()) {
    return "https://api-driverreporting-miljoeservice-staging.azurewebsites.net/api/";
  }
  else {
    return 'https://api.miljoeservice.dk/api/';
  }
}

// De skal lige have en snak om forkørsel

function isLocalhost() {
  return document.URL.indexOf('localhost') !== -1;
}

function isStaging() {
  return document.URL.indexOf('staging') !== -1;
}

function isProduction() {
  return !isStaging() && !isLocalhost();
}
